import { combineReducers } from 'redux';
import { reducer as auth } from '@nike/oauth-client';
import adGroups from '../auth/adGroupReducer';

const rootReducer = combineReducers({
  auth,
  adGroups
  // Add other reducers here as needed
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;

